import { render } from "./Home.vue?vue&type=template&id=a4094e60&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=a4094e60&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2122201245/src/dapp.nftea.studio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4094e60"]])

export default __exports__